import Vue from 'vue';
import { EventBus } from '../services/event-bus';

Vue.directive('table-lines', {
  inserted($table) {
    EventBus.$on('table-data-loaded', () => {
      const $tbody = $table.children[1];
      const $tr = $tbody.children[0].cloneNode(true);

      $tr.classList.add('table-lines');

      [...$tr.children].forEach(($td) => {
        $td.innerHTML = '';
      });

      $tbody.appendChild($tr);
    });
  },
});
